define('util/savitzky-golay',["require", "exports", "./vector"], function (require, exports, vector_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.smoothPositionN = exports.smoothPointsN = exports.smoothPoints = void 0;
    // Convolution matrix
    // Simple moving average filter
    // const c = new Array(size).fill(1 / size)
    // Savitzky and Golay 1964. Smoothing and Differentiation of Data by Simplified Least-Squares Procedures.
    // Quadratic cubic coefficients
    var c = [-78, -13, 42, 87, 122, 147, 162, 167, 162, 147, 122, 87, 42, -13, -78];
    // First derivative quadratic coefficients
    // const cDerive1 = [-7, -6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 7]
    // Second derivative quadratic coefficients
    // const cDerive2 = [91, 52, 19, -8, -29, -48, -53, -56, -53, -48, -29, -8, 19, 52, 91]
    var size = c.length;
    var half = Math.floor(size / 2);
    var sum = c.reduce(function (a, b) { return a + b; });
    // Normalize C
    var cNorm = c.map(function (x) { return x / sum; });
    // Project out the velocity component
    // If you wanted to adjust for altitude, apply trueToIndicated here.
    var vD = function (point) { return -point.climb; };
    var vN = function (point) { return point.vN; };
    var vE = function (point) { return point.vE; };
    /**
     * Savitzky-Golay filter for point velocity smoothing
     */
    function smoothPoints(data) {
        // Copy head and tail, apply convolution filter to middle
        for (var i = 0; i < data.length; i++) {
            if (i <= half || data.length - half <= i) {
                // Copy head and tail data
                data[i].smooth = {
                    vD: vD(data[i]),
                    vN: vN(data[i]),
                    vE: vE(data[i])
                };
            }
            else {
                // Apply convolution filter
                var start = i - half;
                var slice = data.slice(start, start + size);
                data[i].smooth = {
                    vD: (0, vector_1.dotMap)(slice, cNorm, vD),
                    vN: (0, vector_1.dotMap)(slice, cNorm, vN),
                    vE: (0, vector_1.dotMap)(slice, cNorm, vE)
                };
                // TODO: Get acceleration from filter
            }
        }
    }
    exports.smoothPoints = smoothPoints;
    // all sg coefficients
    var cMX = [
        [-3, 12, 17, 12, -3],
        [-2, 3, 6, 7, 6, 3, -2],
        [-21, 14, 39, 54, 59, 54, 39, 14, -21],
        [-36, 9, 44, 69, 84, 89, 84, 69, 44, 9, -36],
        [-11, 0, 9, 16, 21, 24, 25, 24, 21, 16, 9, 0, -11],
        [-78, -13, 42, 87, 122, 147, 162, 167, 162, 147, 122, 87, 42, -13, -78],
        [-21, -6, 7, 18, 27, 34, 39, 42, 43, 42, 39, 34, 27, 18, 7, -6, -21],
        [-136, -51, 24, 89, 144, 189, 224, 249, 264, 269, 264, 249, 224, 189, 144, 89, 24, -51, -136],
        [-171, -76, 9, 84, 149, 204, 249, 284, 309, 324, 329, 324, 309, 284, 249, 204, 149, 84, 9, -76, -171],
        [-42, -21, -2, 15, 30, 43, 54, 63, 70, 75, 78, 79, 78, 75, 70, 63, 54, 43, 30, 15, -2, -21, -42],
        [-253, -138, -33, 62, 147, 222, 287, 343, 387, 422, 447, 462, 467, 462, 447, 422, 387, 343, 287, 222, 147, 62, -33, -138, -253]
    ];
    var cMN = cMX.map(function (xar) {
        var psum = xar.reduce(function (a, b) { return a + b; }); //b!=xar[0]?a + 2*b:a+b)
        //console.log("psum, ",psum)
        return xar.map(function (x) { return x / psum; });
    });
    // smooth with filter length 5 - 25
    function smoothPointsN(data, filterlength, secondfilterlength, thirdfilterlength) {
        // todo error check length
        var nsize = filterlength;
        var nhalf = Math.floor(nsize / 2);
        var ncNorm = cMN.find(function (xar) { return xar.length == filterlength; });
        if (!ncNorm) {
            console.error("bad filter length");
        }
        else {
            // Copy head and tail, apply convolution filter to middle
            for (var i = 0; i < data.length; i++) {
                if (i <= nhalf || data.length - nhalf <= i) {
                    // Copy head and tail data
                    data[i].smooth = {
                        vD: vD(data[i]),
                        vN: vN(data[i]),
                        vE: vE(data[i])
                    };
                }
                else {
                    // Apply convolution filter
                    var start = i - nhalf;
                    var slice = data.slice(start, start + nsize);
                    data[i].smooth = {
                        vD: (0, vector_1.dotMap)(slice, ncNorm, vD),
                        vN: (0, vector_1.dotMap)(slice, ncNorm, vN),
                        vE: (0, vector_1.dotMap)(slice, ncNorm, vE)
                    };
                }
            }
        }
        if (secondfilterlength) {
            var tsize = secondfilterlength;
            var thalf = Math.floor(tsize / 2);
            var tcNorm = cMN.find(function (xar) { return xar.length == secondfilterlength; });
            var tvD = function (point) { return point.smooth.vD; };
            var tvN = function (point) { return point.smooth.vN; };
            var tvE = function (point) { return point.smooth.vE; };
            if (!tcNorm) {
                console.error("bad filter length");
            }
            else {
                // Copy head and tail, apply convolution filter to middle
                for (var i = 0; i < data.length; i++) {
                    if (i <= thalf || data.length - thalf <= i) {
                        // Copy head and tail data
                        data[i].smooth = {
                            vD: tvD(data[i]),
                            vN: tvN(data[i]),
                            vE: tvE(data[i])
                        };
                    }
                    else {
                        // Apply convolution filter
                        var start = i - thalf;
                        var slice = data.slice(start, start + tsize);
                        data[i].smooth = {
                            vD: (0, vector_1.dotMap)(slice, tcNorm, tvD),
                            vN: (0, vector_1.dotMap)(slice, tcNorm, tvN),
                            vE: (0, vector_1.dotMap)(slice, tcNorm, tvE)
                        };
                    }
                }
            }
        }
        if (thirdfilterlength) {
            var thsize = thirdfilterlength;
            var thhalf = Math.floor(thsize / 2);
            var thcNorm = cMN.find(function (xar) { return xar.length == thirdfilterlength; });
            var thvD = function (point) { return point.smooth.vD; };
            var thvN = function (point) { return point.smooth.vN; };
            var thvE = function (point) { return point.smooth.vE; };
            if (!thcNorm) {
                console.error("bad filter length");
            }
            else {
                // Copy head and tail, apply convolution filter to middle
                for (var i = 0; i < data.length; i++) {
                    if (i <= thhalf || data.length - thhalf <= i) {
                        // Copy head and tail data
                        data[i].smooth = {
                            vD: thvD(data[i]),
                            vN: thvN(data[i]),
                            vE: thvE(data[i])
                        };
                    }
                    else {
                        // Apply convolution filter
                        var start = i - thhalf;
                        var slice = data.slice(start, start + thsize);
                        data[i].smooth = {
                            vD: (0, vector_1.dotMap)(slice, thcNorm, thvD),
                            vN: (0, vector_1.dotMap)(slice, thcNorm, thvN),
                            vE: (0, vector_1.dotMap)(slice, thcNorm, thvE)
                        };
                    }
                }
            }
        }
    }
    exports.smoothPointsN = smoothPointsN;
    function smoothPositionN(data, filterlength, secondfilterlength, thirdfilterlength) {
        // todo error check length
        var nsize = filterlength;
        var nhalf = Math.floor(nsize / 2);
        var ncNorm = cMN.find(function (xar) { return xar.length == filterlength; });
        var lAT = function (point) { return point.lat; };
        var lNG = function (point) { return point.lng; };
        var aLT = function (point) { return point.alt; };
        if (!ncNorm) {
            console.error("bad filter length");
        }
        else {
            // Copy head and tail, apply convolution filter to middle
            for (var i = 0; i < data.length; i++) {
                if (i <= nhalf || data.length - nhalf <= i) {
                    // Copy head and tail data
                    data[i].lat = lAT(data[i]);
                    data[i].lng = lNG(data[i]);
                    data[i].alt = aLT(data[i]);
                }
                else {
                    // Apply convolution filter
                    var start = i - nhalf;
                    var slice = data.slice(start, start + nsize);
                    data[i].lat = (0, vector_1.dotMap)(slice, ncNorm, lAT),
                        data[i].lng = (0, vector_1.dotMap)(slice, ncNorm, lNG),
                        data[i].alt = (0, vector_1.dotMap)(slice, ncNorm, aLT);
                }
            }
        }
        if (secondfilterlength) {
            var ssize = secondfilterlength;
            var shalf = Math.floor(ssize / 2);
            var scNorm = cMN.find(function (xar) { return xar.length == secondfilterlength; });
            if (!scNorm) {
                console.error("bad filter length");
            }
            else {
                // Copy head and tail, apply convolution filter to middle
                for (var i = 0; i < data.length; i++) {
                    if (i <= shalf || data.length - shalf <= i) {
                        // Copy head and tail data
                        data[i].lat = lAT(data[i]);
                        data[i].lng = lNG(data[i]);
                        data[i].alt = aLT(data[i]);
                    }
                    else {
                        // Apply convolution filter
                        var start = i - shalf;
                        var slice = data.slice(start, start + ssize);
                        data[i].lat = (0, vector_1.dotMap)(slice, scNorm, lAT),
                            data[i].lng = (0, vector_1.dotMap)(slice, scNorm, lNG),
                            data[i].alt = (0, vector_1.dotMap)(slice, scNorm, aLT);
                    }
                }
            }
        }
        if (thirdfilterlength) {
            var tsize = thirdfilterlength;
            var thalf = Math.floor(tsize / 2);
            var tcNorm = cMN.find(function (xar) { return xar.length == thirdfilterlength; });
            if (!tcNorm) {
                console.error("bad filter length");
            }
            else {
                // Copy head and tail, apply convolution filter to middle
                for (var i = 0; i < data.length; i++) {
                    if (i <= thalf || data.length - thalf <= i) {
                        // Copy head and tail data
                        data[i].lat = lAT(data[i]);
                        data[i].lng = lNG(data[i]);
                        data[i].alt = aLT(data[i]);
                    }
                    else {
                        // Apply convolution filter
                        var start = i - thalf;
                        var slice = data.slice(start, start + tsize);
                        data[i].lat = (0, vector_1.dotMap)(slice, tcNorm, lAT),
                            data[i].lng = (0, vector_1.dotMap)(slice, tcNorm, lNG),
                            data[i].alt = (0, vector_1.dotMap)(slice, tcNorm, aLT);
                    }
                }
            }
        }
    }
    exports.smoothPositionN = smoothPositionN;
});
//# sourceMappingURL=/assets/javascripts/util/savitzky-golay.js.map;
